var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ValidationProvider', {
    staticClass: "form-check",
    attrs: {
      "tag": "div",
      "rules": _vm.rules,
      "vid": _vm.vid,
      "name": _vm.name || _vm.label
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        errors,
        ariaInput
      }) {
        return [_c('input', _vm._b({
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.innerValue,
            expression: "innerValue"
          }],
          ref: "input",
          staticClass: "form-check-input",
          class: {
            'is-invalid alert-danger': errors[0]
          },
          attrs: {
            "type": "checkbox",
            "id": _vm.vid,
            "name": _vm.name,
            "disabled": _vm.disabled
          },
          domProps: {
            "checked": Array.isArray(_vm.innerValue) ? _vm._i(_vm.innerValue, null) > -1 : _vm.innerValue
          },
          on: {
            "change": function ($event) {
              var $$a = _vm.innerValue,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.innerValue = $$a.concat([$$v]));
                } else {
                  $$i > -1 && (_vm.innerValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.innerValue = $$c;
              }
            }
          }
        }, 'input', ariaInput, false)), _c('label', {
          staticClass: "form-check-label w-100",
          class: {
            'text-danger': errors[0]
          },
          attrs: {
            "for": _vm.vid || _vm.name
          },
          domProps: {
            "innerHTML": _vm._s(_vm.label)
          },
          on: {
            "click": _vm.toggle
          }
        }), _c('div', {
          staticClass: "invalid-feedback"
        }, [_vm._v(_vm._s(errors[0]))]), _vm.note && !errors[0] ? _c('small', {
          staticClass: "form-text text-muted"
        }, [_vm._v(_vm._s(_vm.note))]) : _vm._e()];
      }
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };